




import React, { useState, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'


import LocalStorageService from '../../../services/LocalStorageService'
import { getRecordTerm } from '../../../services/TermsService'

// Appt Components
import Box from '../../../components/simple/box/Box'
import Divider from '../../../components/simple/divider/Divider'

import { VerticalTimeline }  from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';

import ReportService from '../../../services/ReportService.js'
import TimelineCard from '../../../components/compound/timeline/TimelineCard.js'
import PulseLoader from 'react-spinners/PulseLoader.js'
import { isServiceAdmin } from '../../../utils/permissions.js'

import '../../../custom.css'
import Text from '../../../components/simple/text/Text.js'

function Overview (props) {
  const navigate = useNavigate()

  const [reportData, setReportData] = useState({})
  const [loading, setLoading] = useState(false)

  const apiToken = LocalStorageService.get('apiToken')
  const activeOrg = LocalStorageService.get('activeOrg')
  const params = useParams()
  const userId = params.userid

  const goBack = () => {
      navigate(-1)
  }

  useEffect(() => {
      (async () => {
          if (!userId) { return }

          setLoading(true)
          await loadReport()
          setLoading(false)

      })()
  }, [userId])


  const loadReport = async () => {


    const isAdmin = isServiceAdmin();

      let responses = await ReportService.getReport(
          apiToken,
        {
              orgId: activeOrg.id,
              studentId: userId,
              // limit: 100,
              // page: 1
          },
          {
              submissionType: 'general',
              query: [
                  {
                  "key": "studentName",
                      "operator": "is",
                      "response": userId,
                      "relation": null
                  }
              ],
              reports: [
                  isAdmin ? "activitySummary" : "myActivitySummary"
              ],
          },
      )

      setReportData(responses)

    }

  return (
    <Box gridArea='main' background='white' direction='column' gap='small' round='small' margin={{ bottom: 'large' }}>
      <Divider color='primary' />
        {!loading && !reportData?.activitySummary?.length && (
        <Box align='center' pad={{ vertical: 'medium' }}><Text>No activity records found, use Record &amp; Plan to create Incidents and {getRecordTerm(LocalStorageService.get('terms'), 'smartPlanBuilderTerm', 'Smart Plan')}.</Text></Box>
          )}
        <Box
          gap='small'
          round='small'
      >
          {!loading && reportData?.activitySummary?.length > 0 && <VerticalTimeline lineColor='#ddd' >
            {reportData?.activitySummary?.map(record => <TimelineCard record={record} />)}
          </VerticalTimeline>}
          {loading && <Box align='center' pad={{ vertical: 'medium' }}>
            <PulseLoader color='#ff8300' size={15} margin={5} />
          </Box>}
      </Box>
    </Box>
  )
}
export default Overview
